
(function() {
  var result = { translations: { "id": { "i18n": { "duration": { "seconds": "{{ seconds }} dtk", "minutes": "{{ minutes }}  mnt", "hours": "{{ hours }} jam", "hoursAndMinutes": "{{ hours }} jam {{ minutes }} mnt", "days": "{{ days }} hari", "shortForm": { "seconds": "{{ seconds }}d", "minutes": "{{ minutes }}m", "hours": "{{ hours }}j", "days": "{{ days }}h", "hoursAndMinutes": "{{ hours }}j {{ minutes }}m" } }, "dateTime": { "quarterAndYear": "K{{quarterNumber}} {{yearNumber}}" }, "numberRepresentation": { "fraction": "{{ numerator }}/{{ denominator }}", "numberWithCurrencyCode": "{{currencyCode}} {{amountNumberValue}}", "phoneNumberWithExtension": "{{phoneNumber}}, ext. {{extension}}" } } } } };
  result.translationsLoaded = {
  "I18n": {
    "id": "static-7.1291"
  }
};
  result.translationsAvailable = {
  "I18n": {
    "af": "static-7.1291",
    "ar-eg": "static-7.1291",
    "bg": "static-7.1291",
    "bn": "static-7.1291",
    "ca-es": "static-7.1291",
    "cs": "static-7.1291",
    "da": "static-7.1291",
    "de": "static-7.1291",
    "el": "static-7.1291",
    "en-gb": "static-7.1291",
    "en": "static-7.1291",
    "es-mx": "static-7.1291",
    "es": "static-7.1291",
    "et": "static-7.1291",
    "fi": "static-7.1291",
    "fr-ca": "static-7.1291",
    "fr": "static-7.1291",
    "he-il": "static-7.1291",
    "hi": "static-7.1291",
    "hr": "static-7.1291",
    "hu": "static-7.1291",
    "id": "static-7.1291",
    "it": "static-7.1291",
    "ja": "static-7.1291",
    "ko": "static-7.1291",
    "lt": "static-7.1291",
    "ms": "static-7.1291",
    "nl": "static-7.1291",
    "no": "static-7.1291",
    "pl": "static-7.1291",
    "pt-br": "static-7.1291",
    "pt-pt": "static-7.1291",
    "ro": "static-7.1291",
    "ru": "static-7.1291",
    "sk": "static-7.1291",
    "sl": "static-7.1291",
    "sv": "static-7.1291",
    "th": "static-7.1291",
    "tl": "static-7.1291",
    "tr": "static-7.1291",
    "uk": "static-7.1291",
    "vi": "static-7.1291",
    "x-pseudo": "static-7.1291",
    "zh-cn": "static-7.1291",
    "zh-hk": "static-7.1291",
    "zh-tw": "static-7.1291"
  }
};
  hns('I18n', result);
  if (typeof I18n === 'object' && I18n.trigger) { I18n.trigger('loaded:I18n:id', {version: 'static-7.1291'}); }
})();


